import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import DesktopComments728x90Gak from './gak/DesktopComments728x90';
import DesktopComments728x90Fs from './freestar/DesktopComments728x90';
const DesktopComments728x90 = ({ safety ='off'  })=>{
    const isFreestar = useFlag('ads_freestar');
    if (isFreestar) {
        return /*#__PURE__*/ React.createElement(DesktopComments728x90Fs, {
            safety: safety
        });
    }
    return /*#__PURE__*/ React.createElement(DesktopComments728x90Gak, {
        safety: safety
    });
};
DesktopComments728x90.displayName = 'DesktopComments728x90';
export default DesktopComments728x90;
